import { z } from 'zod'

export const agreeTermsSchema = z.object({
  /** 是否已同意條款	 */
  agreeTerms: z.boolean()
})

export interface AgreeTerms extends z.infer<typeof agreeTermsSchema> {}
